module.exports = __webpack_public_path__ + "ENG_SPS6-HitByBall-577cacb53a4153bb555b545c2a657676.png";